import React, { useState } from "react";
import "./index";

function App() {
  const [result, setResult] = useState("");

  const handleClick = (e) => {
    setResult(result.concat(e.target.name));
  };

  const clear = () => {
    setResult("");
  };

  const backspace = () => {
    setResult(result.slice(0, -1));
  };

  const calculate = () => {
    try {
      setResult(eval(result).toString());
    } catch (error) {
      setResult("Error");
    }
  };

  return (
    <div class="calculator">
      <div class="screen">
        <input type="text" value={result} />
      </div>
      <div class="buttons">
        <button onClick={clear} class="light">
          AC
        </button>
        <button onClick={backspace} class="light">
          C
        </button>
        <button onClick={handleClick} name="%" class="light">
          %
        </button>
        <button onClick={handleClick} name="/" class="operator">
          &divide;
        </button>

        <button onClick={handleClick} name="7" class="dark">
          7
        </button>
        <button onClick={handleClick} name="8" class="dark">
          8
        </button>
        <button onClick={handleClick} name="9" class="dark">
          9
        </button>
        <button onClick={handleClick} name="*" class="operator">
          &times;
        </button>

        <button onClick={handleClick} name="4" class="dark">
          4
        </button>
        <button onClick={handleClick} name="5" class="dark">
          5
        </button>
        <button onClick={handleClick} name="6" class="dark">
          6
        </button>
        <button onClick={handleClick} name="-" class="operator">
          -
        </button>

        <button onClick={handleClick} name="1" class="dark">
          1
        </button>
        <button onClick={handleClick} name="2" class="dark">
          2
        </button>
        <button onClick={handleClick} name="3" class="dark">
          3
        </button>
        <button onClick={handleClick} name="+" class="operator">
          +
        </button>

        <button onClick={handleClick} name="0" className="double">
          0
        </button>
        <button onClick={handleClick} name="00">
          00
        </button>

        <button onClick={handleClick} name="." class="dark">
          .
        </button>
        <button onClick={calculate} class="operator">
          =
        </button>
      </div>
    </div>
  );
}

export default App;
